export var toUpperCase = function toUpperCase(input) {
  if (typeof input === 'string') {
    return input.toUpperCase();
  }
  return null;
};